import React from 'react';
import PropTypes from 'prop-types';
import {useComponentProps} from 'helpers/hooks/utils';
import StyledEditorMenuButtonStrikethrough
  from 'components/atoms/Editors/EditorMenuButtonStrikethrough/EditorMenuButtonStrikethrough.styles';

const EditorMenuButtonStrikethrough = React.forwardRef((props, ref) => {
  const innerProps = useComponentProps(props, 'EditorMenuButtonStrikethrough');

  return <StyledEditorMenuButtonStrikethrough buttonRef={ref} {...innerProps} />
});

EditorMenuButtonStrikethrough.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ])
};

export default EditorMenuButtonStrikethrough;
